import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';

interface SaveAsTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  name: string;
  onNameChange: (value: string) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
  loading: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export default function SaveAsTemplateDialog({
  open,
  onOpenChange,
  name,
  onNameChange,
  description,
  onDescriptionChange,
  loading,
  onCancel,
  onSave,
}: SaveAsTemplateDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Opslaan als template</DialogTitle>
          <DialogDescription>
            Sla deze offerte op als herbruikbare template
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div className="space-y-2">
            <Label htmlFor="editorTplName">Template naam</Label>
            <Input
              id="editorTplName"
              value={name}
              onChange={(e) => onNameChange(e.target.value)}
              disabled={loading}
              placeholder="Bijv. Standaard offerte"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="editorTplDesc">Beschrijving (optioneel)</Label>
            <textarea
              id="editorTplDesc"
              value={description}
              onChange={(e) => onDescriptionChange(e.target.value)}
              rows={2}
              disabled={loading}
              className="flex w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
              placeholder="Korte beschrijving van deze template..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            Annuleren
          </Button>
          <Button onClick={onSave} disabled={!name.trim() || loading}>
            {loading ? 'Opslaan...' : 'Opslaan als template'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
